export const jobTitle = [
    {
        id: 0,
        active: true,
        title: 'ENGINEERING MANAGER'
    },{
        id: 1,
        active: true,
        title: 'EV CHARGING PLATFORM LEADER'
    },{
        id: 2,
        active: true,
        title: 'SALESFORCE DEVELOPER / ADMIN'
    },{
        id: 4,
        active: true,
        title: 'FRONT-END DEVELOPER'
    }, {
        id: 3,
        active: true,
        title: 'FULL-STACK DEVELOPER'
    }
];

export const aboutMe = [
    {
        id: 0,
        active: false,
        content: 'Hi there! My name is Keny Lin.'
    },{
        id: 1,
        active: true,
        content: 'Product and engineering leader with 22+ years of experience delivering customer-facing digital platforms, EV charging solutions, enterprise systems, and cloud-based operations across North America and Asia.'
    },{
        id: 2,
        active: true,
        content: 'Hands-on expertise in EV charging ecosystems, OCPP integrations, payment systems, interoperability, charger diagnostics, and CPO/OEM operations. Proven ability to define product strategy, align cross-functional stakeholders, drive roadmap execution, and improve end-to-end customer experience for scalable technology platforms.'
    },{
        id: 3,
        active: true,
        content: 'Strong blend of technical depth, operational leadership, and business acumen with experience partnering across engineering, UX, operations, sales, and executive leadership teams. Bilingual in English and Mandarin Chinese.'
    }
];

export const aboutMeSolution = [
    {
        id: 0,
        active: true,
        title: 'EV Charging Platform Strategy & Operations',
        content: 'Engineering leader driving EV charging platform capabilities including OCPP 1.6/2.0 integration, CTEP compliance, payment platform integration (Payter, Nayax), idle fee management, and CPO/OEM operational readiness across North America.'
    },{
        id: 1,
        active: true,
        title: 'Program & Cross-Functional Leadership',
        content: 'Technical Program Manager with 22+ years leading cross-functional initiatives. Expert in roadmap planning, stakeholder alignment, vendor management, and delivering results across engineering, UX, operations, and executive teams.'
    },{
        id: 2,
        active: true,
        title: 'Salesforce Solutions',
        content: 'Salesforce Certified Administrator with 12+ years of experience in Sales Cloud, Service Cloud, Marketing Cloud, and Einstein Analytics. Proficient in workflow automation, SLA tracking, Apex, Visualforce, Lightning, and MuleSoft API integrations.'
    }
    ,{
        id: 3,
        active: true,
        title: 'Full-Stack Developer',
        content: 'Experienced full-stack developer proficient in Python, JavaScript, React, Flask, SQL, and ASP.Net/C#. Skilled in REST/GraphQL API integration, responsive UI/UX design, and deploying SaaS applications on AWS, Azure, and GCP.'
    }
];

export const leftSkills =[
    {
        id: 0,
        active: true,
        title: 'EV Charging Product Strategy & Operations',
        content: 'OCPP 1.6/2.0, EVSE, CPO Platforms, CTEP Compliance, L2/L3 Charger Configuration, Payment Integration, Remote Charger Monitoring'
    },{
        id: 1,
        active: true,
        title: 'Technical Leadership & Cross-Functional Supervision',
        content: 'Roadmap Planning, Stakeholder Alignment, Vendor Management, SDLC, Agile, Scrum'
    },{
        id: 2,
        active: true,
        title: 'Customer Experience & Operations',
        content: 'User Journey Design, SLA Management, Firmware Diagnostics, Root Cause Analysis, ITSM, ITIL'
    },{
        id: 3,
        active: true,
        title: 'Enterprise Platforms',
        content: 'Salesforce Sales/Service/Marketing Cloud, Oracle EBS, Workday, ADP, MuleSoft, Microsoft 365'
    },{
        id: 4,
        active: true,
        title: 'Business Intelligence & Reporting',
        content: 'Power BI, Tableau, Salesforce Einstein Analytics, SOQL, SAQL, Data-Driven KPI Management'
    },{
        id: 5,
        active: true,
        title: 'Cloud & Infrastructure',
        content: 'AWS, Azure, GCP, VMware, LAN/WAN/VPN, Databases, Servers, Storage'
    }
];

export const rightSkills =[
    {
        id: 0,
        active: true,
        title: 'Programming Languages',
        content: 'Python, JavaScript, SQL, HTML5, CSS3, C#, Salesforce Apex, SOQL'
    },{
        id: 1,
        active: true,
        title: 'Frameworks & Technologies',
        content: 'React, Flask, ASP.Net, REST, GraphQL, Node.js, Express, Vue.js, WordPress'
    },{
        id: 2,
        active: true,
        title: 'Development & Collaboration Tools',
        content: 'Git, Docker, Jenkins, Jira, Figma, Photoshop'
    },{
        id: 3,
        active: true,
        title: 'Database Management',
        content: 'MS SQL, Oracle, MySQL, MongoDB, Salesforce SOQL, SAQL'
    },{
        id: 4,
        active: true,
        title: 'Payment & Charging Integrations',
        content: 'Payter, Nayax, OCPP DataTransfer workflows, session cost calculation, idle fee management'
    },{
        id: 5,
        active: true,
        title: 'AI/ML & Analytics',
        content: 'Computer Vision, OpenCV, YOLO, MediaPipe, Generative AI, Salesforce Einstein Analytics'
    }
];
